import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StripeScriptWrapper from './stripeScriptWrapper';
import CardCapture from './cardCapture';

const Container = styled.div`
  margin: auto;
  width: 450px;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const StripePayment = ({
  service,
  paymentIntentSecret,
  featureName,
  publishableKey,
  onSuccess,
  translations,
}) =>
  paymentIntentSecret ? (
    <Container className="stripe-payment-container">
      <StripeScriptWrapper publishableKey={publishableKey}>
        <CardCapture
          service={service}
          paymentIntentSecret={paymentIntentSecret}
          featureName={featureName}
          onSuccess={onSuccess}
          translations={translations}
        />
      </StripeScriptWrapper>
    </Container>
  ) : null;

StripePayment.defaultProps = {
  service: undefined,
  featureName: 'stripePayment',
  onSuccess: () => {},
  translations: undefined,
};

StripePayment.propTypes = {
  service: PropTypes.string,
  featureName: PropTypes.string,
  paymentIntentSecret: PropTypes.string.isRequired,
  publishableKey: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
  translations: PropTypes.shape({
    title: PropTypes.string,
    submitButton: PropTypes.string,
  }),
};

export default StripePayment;
